import { FC } from 'react';
import { DataUsingSetting } from './DataUsingSetting/DataUsingSetting';

export const DataUsingSettingPage: FC = () => {
  return <DataUsingSetting />;
};
